<affichage-hierarchique [listeColonnesAAfficher]="listeColonnes" [listeCartesHierarchiques]="listeCartesHierarchiques"></affichage-hierarchique>